// extracted by mini-css-extract-plugin
export default {"imageSize":"FullEvents_imageSize__OqBF6"};